import { Dices, RefreshCw } from "lucide-react";

const TOPICS = [
  "Is a hot dog a sandwich?",
  "Would it be better to explore the deep ocean or outer space first?",
  "Could we ever bring dinosaurs back to life?",
  "Are octopuses smarter than dogs?",
  "Was the invention of the printing press more important than the internet?",
  "Is time travel actually possible?",
  "Should we try to live on Mars?",
  "Are cats or dogs better pets?",
  "Is it possible that there's life on one of Jupiter's moons?",
  "Did the ancient Egyptians use simple machines or something cleverer to build the pyramids?",
  "Is a tomato a fruit or a vegetable?",
  "Will robots ever be truly creative?",
  "Is Pluto a planet?",
  "Which is the most amazing animal on Earth?",
  "Is it better to be an early bird or a night owl?",
];

const KID_TOPICS = [
  "Are sharks scary or misunderstood?",
  "Would you rather fly like a bird or swim like a dolphin?",
  "Is the Moon made of cheese?",
  "Are dinosaurs related to chickens?",
  "Do plants have feelings?",
  "Is Pluto a planet?",
  "Could a penguin live in the desert?",
  "Which is the best superpower: flying or being invisible?",
  "Do fish ever sleep?",
  "Is a spider an insect?",
  "Why is the sky blue and not green?",
  "Are bats birds?",
  "Can an elephant jump?",
  "Is it always cold in space?",
];

export const randomTopic = (kids) => {
  const list = kids ? KID_TOPICS : TOPICS;
  return list[Math.floor(Math.random() * list.length)];
};

export const SurpriseButton = ({ onClick, disabled, big = false }) => (
  <button type="button" data-testid={big ? "surprise-me-big-btn" : "surprise-me-btn"} onClick={onClick} disabled={disabled} className={`what-surprise ${big ? "is-big" : ""}`}>
    <Dices size={big ? 18 : 15} /> Surprise me
  </button>
);

export const OneMoreRound = ({ onClick }) => (
  <div className="mt-6 flex justify-start">
    <button type="button" data-testid="one-more-round-btn" onClick={onClick} className="what-more-round">
      <RefreshCw size={15} /> One more round
    </button>
  </div>
);
